// extracted by mini-css-extract-plugin
export var image = "BusinessTransformationWithAI-module--image--25693";
export var item = "BusinessTransformationWithAI-module--item--4ec29";
export var list = "BusinessTransformationWithAI-module--list--3da13";